import React from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

interface LocationCardFieldProps {
  label: string;
  children: React.ReactNode;
}

const FieldRoot = styled(Box)({
  padding: "6px 0",
  minWidth: 0,
  overflowWrap: "anywhere",
});

const FieldLabel = styled(Box)({
  fontSize: "0.7143rem",  // 10px at 14px root
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: "0.5px",
  color: "#5E7782",
  marginBottom: 2,
});

const FieldValue = styled(Box)({
  fontSize: "0.9286rem",  // 13px at 14px root
  color: "#324559",
  fontWeight: 500,
});

/**
 * A single label + value field cell for use inside `LocationCard.Fields`.
 *
 * Pass the displayed value as `children` — this allows callers to embed
 * rich content (chips, links, badges) alongside plain text values.
 *
 * @example
 * <LocationCard.Field label="Per Day">$12.00</LocationCard.Field>
 * <LocationCard.Field label="Location Capacity">10 <LocationCard.CapacityAlertBadge … /></LocationCard.Field>
 */
const LocationCardField = ({ label, children }: LocationCardFieldProps) => (
  <FieldRoot>
    <FieldLabel>{label}</FieldLabel>
    <FieldValue>{children}</FieldValue>
  </FieldRoot>
);

export default LocationCardField;

